import { useState, useEffect } from 'react';
import { FileText, Users, Mail, Target, Search, Zap, Clock, PenLine, Settings, BarChart3, TrendingUp, Bot, Globe, UserCog, Send, Brain, CheckSquare, QrCode } from 'lucide-react';

const SECTIONS = [
  {
    title: 'Organisation',
    color: '#C9A84C',
    items: [
      { id: 'taches', icon: CheckSquare, label: 'Taches & Planning', desc: 'Calendrier, rappels Telegram' },
    ],
  },
  {
    title: 'Traiteur',
    color: '#C9A84C',
    items: [
      { id: 'prop-dashboard', icon: FileText, label: 'Propositions', desc: 'Suivi commercial & devis' },
      { id: 'prop-pipeline', icon: Target, label: 'Pipeline', desc: 'Kanban propositions' },
      { id: 'prop-veille', icon: TrendingUp, label: 'Veille & Marche', desc: 'Analyse marche IA' },
    ],
  },
  {
    title: 'Prospection',
    color: '#E07A5F',
    items: [
      { id: 'crm-dashboard', icon: BarChart3, label: 'Tableau de bord', desc: 'Stats prospection' },
      { id: 'crm-rapide', icon: Zap, label: 'Mode rapide', desc: 'Prospection express' },
      { id: 'crm-relances', icon: Clock, label: 'Relances', desc: 'Suivi relances auto' },
      { id: 'crm-pipeline', icon: Target, label: 'Pipeline CRM', desc: 'Kanban prospects' },
      { id: 'crm-recherche', icon: Search, label: 'Recherche', desc: 'Trouver entreprises' },
      { id: 'crm-signatures', icon: PenLine, label: 'Signatures', desc: 'Signatures email' },
      { id: 'crm-config', icon: Settings, label: 'Config', desc: 'Catalogue & parametres' },
    ],
  },
  {
    title: 'Communication',
    color: '#5B8FE0',
    items: [
      { id: 'messagerie', icon: Mail, label: 'Messagerie', desc: 'Emails IMAP' },
      { id: 'telegram', icon: Send, label: 'Telegram', desc: 'Notifications' },
    ],
  },
  {
    title: 'Outils IA',
    color: '#8B5CF6',
    items: [
      { id: 'ia-knowledge', icon: Brain, label: 'Base IA', desc: 'Informer & entrainer l\'IA' },
      { id: 'ia-cowork', icon: Bot, label: 'IA Cowork', desc: 'Assistant IA' },
      { id: 'optimisation', icon: Brain, label: 'Optim IA', desc: 'Analyse & conseils' },
    ],
  },
  {
    title: 'Administration',
    color: '#6B7280',
    items: [
      { id: 'admin-site', icon: Globe, label: 'Gestion Site', desc: 'Site web public' },
      { id: 'qrcode-menu', icon: QrCode, label: 'QR Code Menu', desc: 'Pour la carte du restaurant' },
      { id: 'users', icon: UserCog, label: 'Acces', desc: 'Utilisateurs & roles' },
      { id: 'settings-chef', icon: Settings, label: 'Param. Chef', desc: 'Interface chef' },
    ],
  },
];

export default function GestionHub({ setActiveTab }) {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/users`, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(r => r.json()).then(data => {
      if (Array.isArray(data)) setPendingCount(data.filter(u => u.status === 'pending').length);
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="gestion-hub">
      <div>
        <p className="text-[10px] tracking-[0.2em] uppercase text-[rgb(var(--lm-text-muted))] mb-0.5">Espace de travail</p>
        <h1 className="text-base font-semibold text-[rgb(var(--lm-text))]">Gestion</h1>
      </div>

      {SECTIONS.map((section) => (
        <div key={section.title} className="animate-slide-up" style={{ animationFillMode: 'backwards' }}>
          <p className="text-[9px] tracking-[0.2em] uppercase mb-2 font-medium" style={{ color: section.color }}>{section.title}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
            {section.items.map((item) => {
              const Icon = item.icon;
              const hasBadge = item.id === 'users' && pendingCount > 0;
              return (
                <button key={item.id} onClick={() => setActiveTab(item.id)}
                  className="group relative p-3.5 rounded-xl bg-[rgb(var(--lm-card))] border border-[rgb(var(--lm-border))]/30 hover:shadow-md transition-all text-left"
                  style={{ '--hover-color': section.color }}
                  data-testid={`gestion-${item.id}`}
                  onMouseEnter={(e) => e.currentTarget.style.borderColor = section.color + '60'}
                  onMouseLeave={(e) => e.currentTarget.style.borderColor = ''}
                >
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 transition-colors"
                      style={{ background: section.color + '15' }}>
                      <Icon size={15} style={{ color: section.color }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[11px] font-medium text-[rgb(var(--lm-text))] truncate">{item.label}</p>
                      <p className="text-[9px] text-[rgb(var(--lm-text-muted))] truncate">{item.desc}</p>
                    </div>
                  </div>
                  {hasBadge && (
                    <span className="absolute top-2 right-2 w-4 h-4 rounded-full bg-red-500 text-white text-[8px] font-bold flex items-center justify-center animate-pulse">{pendingCount}</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
